import { render } from "./ModalContentPageStrategy.vue?vue&type=template&id=0ef19efb&lang=true"
import script from "./ModalContentPageStrategy.vue?vue&type=script&lang=js"
export * from "./ModalContentPageStrategy.vue?vue&type=script&lang=js"
script.render = render

export default script